/**
 * Redirect to an external URL, breaking out of any iframe (e.g. Emergent preview).
 * Stripe Checkout / Customer Portal pages refuse to render inside iframes
 * (X-Frame-Options: DENY), so we must navigate the top window.
 */
export function redirectTopLevel(url) {
  if (!url) return;
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return;
    }
  } catch (e) {
    // Cross-origin parent — fall through to window.location
  }
  window.location.href = url;
}
